<template>
	<search-list :pageSizes="[50,75,100]" apiPath="/report/list" :where="where" :order="order" :attributes="group_model" :searchKeys="searchKeys" :handleResponse="handleResponse" ref="sl" notSearchAll>
		<div class="mm-select">
			<div class="column-select">
				<mm-lc title="Time Zone">
					<mm-time-zone v-model="where.time_zone" :clearable="false"/>
				</mm-lc>
				<mm-lc title="Time">
					<mm-date-range v-model="where.time"/>
				</mm-lc>
				<mm-lc title="Group Model">
					<mm-topip-group-model v-model="where.group_model" multiple/>
				</mm-lc>
			</div>
			<div class="column-select">
				<mm-lc title="Advertiser">
					<mm-adv-select v-model="where.adv_id" multiple/>
				</mm-lc>
				<mm-lc title="Channel">
					<mm-channel-select v-model="where.networkid" multiple/>
				</mm-lc>
			</div>
		</div>
		

		<div slot="actions" />
			<mm-table slot="dataTable" slot-scope="res" :res="res"  @sort-change="sortChange" >
			<el-table-column label="IP" prop="ip"/>
			<el-table-column label="Adv. Id" prop="adv_id" key="adv_id" v-if="column_show.adv_id" />
			<el-table-column label="Adv. name" key="adv_name" v-if="column_show.adv_id" >
				<mm-get-detail slot-scope="sp" :row_name="sp.row.adv" :row_id="sp.row.adv_id" row_type='adv' />
			</el-table-column>
			<el-table-column label="Channel Id" prop="networkid" key="networkid" v-if="column_show.networkid" />
			<el-table-column label="Channel Name" prop="network" key="network" v-if="column_show.networkid">
				<mm-get-detail slot-scope="sp" :row_name="sp.row.network" :row_id="sp.row.networkid" row_type='channel' />
			</el-table-column>
			<el-table-column label="Offer Id" prop="offerid" key="offerid" v-if="column_show.offerid"/>
			<el-table-column label="Offer Name" prop="offer_name" key="offer_name" v-if="column_show.offerid">
				<mm-get-detail slot-scope="sp" row_type="offer" :row_id="sp.row.offerid" :row_name="sp.row.offer_name" />
			</el-table-column>
			<el-table-column label="SubChannel" prop="sub_channel" key="sub_channel" v-if="column_show.sub_channel"/>
			<el-table-column label="Clicks" prop="click" sortable='custom' />
			<el-table-column label="Conv." prop="conv" sortable='custom'/>
            <el-table-column label="action">
				<template slot-scope="sp">
					<el-dropdown szie="small" trigger="click">
						<el-button type="primary" plain size="mini">Action</el-button>
						<el-dropdown-menu slot="dropdown" >
							<el-dropdown-item @click.native="addBlackList(sp.row)">Add Black List</el-dropdown-item>
							<el-dropdown-item @click.native="seeInfo(sp.row)">See Info</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</template>

			</el-table-column>
		</mm-table>

	</search-list>
</template>

<script>
export default {
	data() {
		const searchKeys = {
			offerid: { label: "Offer ID" },
			ip: { label:"IP" },
			sub_channel: { label: "SubChannel(APP ID)" },
		};
		return {
			searchKeys,
			order:[['conv','desc']],
			where: {
				time_zone: 0,
				time: {},
				report_model: "topip",
				adv_id:'',
				networkid:'',
			},
			group_model: '',
			column_show:{
				adv_id:false,
				networkid:false,
				offerid:false,
				sub_channel:false,
			}
		};
	},
	methods: {
		handleResponse(body){
			for(const show in this.column_show){
				if(body.rows[0][show] != null){
					this.column_show[show] = true;
					if(this.where.group_model && this.where.group_model.$in.indexOf(show) == -1){
						this.where.group_model.$in.push(show);
					}
				}else{
					this.column_show[show] = false;
				}
			}
		},
		async sortChange(column){
			if(column.order == 'ascending'){
				this.order[0] = [column.prop,'asc']
			}else if(column.order == 'descending'){
				this.order[0] = [column.prop,'desc']
			}else {
				this.order[0] = ['rev','desc']
			}
			await this.$refs.sl.refresh();
		},
		addBlackList(row){
			this.$router.push({ path: "/blackIpCreate",query:{ip:row.ip} });
		},
		seeInfo(row){
			window.open("https://ip.rtbasia.com/?ipstr=" + row.ip);
		}
	},
};
</script>

<style scoped>
.mm-select {
	display: flex;
	flex-direction: column;
}
.column-select {
	display: flex;
	flex-direction: row;
}
.bt-create {
  position: relative;
  right: 0px;
}
</style>
